import MenuItems from "./MenuItems";
import StyledWrapper from "./style";
const Dropdown = ({
  submenus,
  dropdown,
  depthLevel,
  handleChosenCompany,
}: any) => {
  depthLevel = depthLevel + 1;
  const dropdownClass = depthLevel > 1 ? true : false;
  return (
    <StyledWrapper.DropDown
      Submenu={dropdownClass}
      Show={dropdown ? true : false}
      Base={depthLevel === 1 ? true : false}
    >
      {" "}
      {submenus.map((submenu: Object, index: number) => (
        <MenuItems
          items={submenu}
          key={index}
          depthLevel={depthLevel}
          handleChosenCompany={(item: any) => handleChosenCompany(item)}
        />
      ))}{" "}
    </StyledWrapper.DropDown>
  );
};

export default Dropdown;
